import {
	useRunsControllerGetRuns,
	useRunsControllerRemove,
} from '@/api/repository/repositoryComponents'
import toast from 'react-hot-toast'

export const createRunsAdapter = queryClient => {
	const useAll = (appId: string, enabled: boolean = true) => {
		return useRunsControllerGetRuns(
			{ queryParams: { appId } },
			{ enabled: !!appId && enabled }
		)
	}
	const useDelete = () => {
		return useRunsControllerRemove({
			onSuccess: () => {
				queryClient.invalidateQueries()
				toast.success(`Runs deleted`)
			},
		})
	}
	const deleteRuns = (
		variantId: string,
		deleteFn: ReturnType<typeof useDelete>,
		runIds: string[]
	) => {
		deleteFn.mutate({
			pathParams: {
				variantId: variantId,
			},
			queryParams: { runIds },
		})
	}
	return {
		useAll,
		useDelete,
		deleteRuns,
	}
}
